import {Pipe, PipeTransform} from '@angular/core';

declare var moment: any;

@Pipe({name: 'isoToDate'})
export class ISOToDatePipe implements PipeTransform {

  constructor() {
  }

  transform(value: string, args: string): string {

    let date;
    value = value.toString();
    if (!Number.parseInt(value) || value.indexOf('T') >= 0) {
      date = moment(value)._d;
    } else {
      date = moment.unix(value)._d;
      if (date.getFullYear() > 3000) {
        date = moment.unix(Number.parseInt(value) / 1000)._d;
      }
    }

    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    let year = date.getFullYear();

    const resultDate = day + '-' + month + '-' + year;
    if (args == 'dateOnly')
      return resultDate;

    let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    return resultDate + ', at ' + hours + ':' + minutes + ':' + seconds;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/iso-to-date.pipe.ts